// extracted by mini-css-extract-plugin
export var closeButton = "_55-0";